import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'trackingGroupManagementExperience.listExport'

const TrackingGroupManagementTrackingGroupListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default TrackingGroupManagementTrackingGroupListExportSlice
